// src/components/TopButton/TopButton.jsx
import { useEffect, useState } from 'react';

function TopButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  // 스크롤 이벤트 핸들러
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / documentHeight) * 100;

      setIsVisible(scrollTop > 10);
      setScrollProgress(scrollPercent);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 버튼 클릭 시 페이지 최상단으로 이동
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      className={`top-button ${isVisible ? 'show' : ''}`}
      onClick={scrollToTop}
      style={{ '--scroll-progress': `${scrollProgress}%` }}
    >
      <div className="fixed-arrow-top"></div>
    </button>
  );
}

export default TopButton;
